/* HYH — Ruleta (spin-to-win nativo). Reemplazo de Wheelio. Autocontenido.
 *
 * ── CONTRATO BACKEND (POST cfg.endpoint, default /api/spin) ──────────────────
 *  Request  (Content-Type: application/json):
 *    { email:string, ts:number,      // ts = ms desde que se abrió el popup (anti-bot)
 *      company:string,               // honeypot: DEBE venir vacío, si no => descartar
 *      shop:string, source:"ruleta" }
 *  Response OK (200):
 *    { ok:true,
 *      prize:{ tier:"DISCOUNT_5"|"DISCOUNT_10"|"DISCOUNT_15"|"FREE_SHIPPING",
 *              label:string, sliceIndex:0..11 },   // sliceIndex = sector donde aterriza
 *      code:"RULETA-XXXXXX",
 *      expiresAt:"<ISO-8601, now+1h>" }
 *  Response NO-OK (200/4xx):
 *    { ok:false, reason:"already_spun"|"invalid_email"|"rate_limited" }
 *
 *  El SERVIDOR decide el premio y sliceIndex (las odds viven en el server). El
 *  front solo anima hasta ese sliceIndex. Con cfg.mock=true se simula acá con las
 *  odds de la config Wheelio (ver MOCK_ODDS). Para pasar al backend real: apagar
 *  "Modo mock" y setear la URL del endpoint en el editor de temas. Nada más.
 *
 * ── CONTRATO EMBUDO (POST <endpoint con /spin → /track>) ─────────────────────
 *  Request: { event:"shown"|"spun" }   — fire-and-forget, nunca bloquea el giro.
 *  'shown' = apertura automática del popup. 'spun' = giro con email capturado en
 *  Shopify (los degradados a fallback NO cuentan: ahí el email se perdió).
 *  Alimenta el metafield ruleta/stats, del que sale la conversión del A/B vs
 *  Wheelio. Sin estas 2 llamadas el embudo queda en 0 y /api/stats miente.
 * ─────────────────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';
  var root = document.getElementById('hyh-ruleta');
  if (!root) return;

  var cfg;
  try { cfg = JSON.parse(root.querySelector('.ruleta__config').textContent); }
  catch (e) { return; }

  /* ---------- A/B 50/50 (Wheelio vs Ruleta nativa) ----------
   * Bucket estable por visitante en localStorage:
   *   "W" (control) -> Wheelio normal, la ruleta nativa NO se muestra.
   *   "N" (nativo)  -> se muestra la ruleta nativa Y se suprime Wheelio.
   * Override de QA: ?ruleta_bucket=N|W  o  window.__ruletaBucket('N'|'W').
   */
  var LS_BUCKET = 'hyh:ruleta:bucket';
  function forcedBucket() {
    var m = /[?&]ruleta_bucket=([WNwn])(?:&|$)/.exec(location.search);
    return m ? m[1].toUpperCase() : null;
  }
  function getBucket() {
    var forced = forcedBucket();
    if (forced) { try { localStorage.setItem(LS_BUCKET, forced); } catch (e) {} return forced; }
    var b = null;
    try { b = localStorage.getItem(LS_BUCKET); } catch (e) {}
    if (b !== 'W' && b !== 'N') {
      b = (Math.random() < 0.5) ? 'W' : 'N';
      try { localStorage.setItem(LS_BUCKET, b); } catch (e) {}
    }
    return b;
  }
  window.__ruletaBucket = function (force) {
    if (force === 'W' || force === 'N') { try { localStorage.setItem(LS_BUCKET, force); } catch (e) {} }
    try { return localStorage.getItem(LS_BUCKET); } catch (e) { return null; }
  };
  // E7 (2026-07-16): A/B terminado por decisión del dueño — nativo al 100%.
  // Se fuerza 'N' para TODOS (pisa cualquier 'W' guardado en localStorage).
  // getBucket()/__ruletaBucket quedan solo como herramienta de QA.
  var BUCKET = 'N';

  // Suprime el widget de Wheelio (launcher .trigger-button-holder + popup .wlo-holder,
  // ambos dentro de #wheelio2-app-cointainer). Es floating/fixed: ocultarlo no toca el layout.
  // Un <style> aplica también a nodos que Wheelio inyecte tarde (CSS es retroactivo);
  // el observer es defensivo por si recrea el contenedor.
  function suppressWheelio() {
    var id = 'hyh-hide-wheelio';
    if (!document.getElementById(id)) {
      var st = document.createElement('style');
      st.id = id;
      st.textContent = '#wheelio2-app-cointainer,.wlo-holder,.trigger-button-holder,[id^="wheelio"]{display:none !important;visibility:hidden !important;pointer-events:none !important;}';
      (document.head || document.documentElement).appendChild(st);
    }
    var hide = function () {
      var c = document.getElementById('wheelio2-app-cointainer');
      if (c) c.style.setProperty('display', 'none', 'important');
    };
    hide();
    try {
      var mo = new MutationObserver(hide);
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 30000);
    } catch (e) {}
  }

  // Sectores en el MISMO orden que Wheelio. win=true => puede salir (server manda).
  var SLICES = [
    { label: '5% OFF',                 tier: 'DISCOUNT_5',    win: true },
    { label: '¡Mala suerte!',          tier: 'LOSE',          win: false },
    { label: '10% OFF',                tier: 'DISCOUNT_10',   win: true },
    { label: '¡Casi!',                 tier: 'LOSE',          win: false },
    { label: '¡Envío gratis!',         tier: 'FREE_SHIPPING', win: true },
    { label: 'Uh... Hoy no es tú día.',tier: 'LOSE',          win: false },
    { label: '15% OFF',                tier: 'DISCOUNT_15',   win: true },
    { label: '¡Por poquito!',          tier: 'LOSE',          win: false },
    { label: '25% OFF',                tier: 'DISCOUNT_25',   win: false }, // dibujado, nunca sale
    { label: '¡Mala suerte!',          tier: 'LOSE',          win: false },
    { label: '$5.000',                 tier: 'AMOUNT_5000',   win: false }, // dibujado, nunca sale
    { label: '¡Prueba Mañana!',        tier: 'LOSE',          win: false }
  ];
  // Odds del mock (idx sector -> peso). Suman 100.
  var MOCK_ODDS = [[0, 54], [2, 36], [6, 9], [4, 1]];

  var LS_SPUN = 'hyh:ruleta:spun';
  var LS_STATE = 'hyh:ruleta';
  var N = SLICES.length, SEG = (2 * Math.PI) / N;

  var $ = function (sel) { return root.querySelector(sel); };
  var dialog = $('.ruleta');
  var canvas = $('.ruleta__canvas');
  var ctx = canvas.getContext('2d');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var openedAt = 0, rot = -Math.PI / 2, tabTimer = null;

  /* ---------- localStorage helpers ---------- */
  function readState() {
    try { return JSON.parse(localStorage.getItem(LS_STATE) || 'null'); } catch (e) { return null; }
  }
  function saveState(s) { try { localStorage.setItem(LS_STATE, JSON.stringify(s)); } catch (e) {} }
  function markSpun() { try { localStorage.setItem(LS_SPUN, '1'); } catch (e) {} }
  function hasSpun() { try { return localStorage.getItem(LS_SPUN) === '1'; } catch (e) { return false; } }
  // Cerrar sin girar (X / declinar / Escape) también debe persistir: sin esto la
  // ruleta se reabría en CADA página para quien no giraba (cazado en auditoría
  // 2026-07-17). Re-elegible tras cfg.dismissDays (default 7).
  var LS_DISMISS = 'hyh:ruleta:dismissed';
  function markDismissed() { try { localStorage.setItem(LS_DISMISS, String(Date.now())); } catch (e) {} }
  function isDismissed() {
    try {
      var t = parseInt(localStorage.getItem(LS_DISMISS) || '0', 10);
      if (!t) return false;
      var days = (cfg && cfg.dismissDays > 0) ? cfg.dismissDays : 7;
      return (Date.now() - t) < days * 864e5;
    } catch (e) { return false; }
  }

  /* ---------- Canvas ---------- */
  function sizeCanvas() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var css = canvas.getBoundingClientRect();
    var w = css.width || 320, h = css.height || 320;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    draw(rot);
  }
  function draw(r) {
    var w = canvas.width / (Math.min(window.devicePixelRatio || 1, 2));
    var cx = w / 2, cy = w / 2, R = w / 2 - 6;
    ctx.clearRect(0, 0, w, w);
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(r);
    for (var i = 0; i < N; i++) {
      var a0 = i * SEG, a1 = a0 + SEG;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.arc(0, 0, R, a0, a1);
      ctx.closePath();
      ctx.fillStyle = (i % 2 === 0) ? cfg.colorA : cfg.colorB;
      ctx.fill();
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(255,255,255,.18)';
      ctx.stroke();
      // etiqueta
      ctx.save();
      ctx.rotate(a0 + SEG / 2);
      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = cfg.labelColor;
      ctx.font = '700 ' + Math.max(11, Math.round(R * 0.085)) + 'px system-ui, sans-serif';
      var label = SLICES[i].label;
      if (label.length > 16) { ctx.font = '700 ' + Math.max(9, Math.round(R * 0.066)) + 'px system-ui, sans-serif'; }
      ctx.fillText(label, R - 12, 1);
      ctx.restore();
    }
    // aro exterior
    ctx.beginPath();
    ctx.arc(0, 0, R, 0, 2 * Math.PI);
    ctx.lineWidth = 4;
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.restore();
  }
  function pointerAngle() {
    // desktop => 3 en punto (0 rad); mobile => 6 en punto (abajo, +y = PI/2)
    return window.matchMedia('(min-width: 750px)').matches ? 0 : Math.PI / 2;
  }
  function spinAnim(sliceIndex, done) {
    var jitter = (Math.random() - 0.5) * SEG * 0.55;
    var center = sliceIndex * SEG + SEG / 2;
    var target = pointerAngle() - center + jitter;
    if (reduceMotion) { rot = target; draw(rot); done(); return; }
    var finalRot = target;
    while (finalRot < rot + 2 * Math.PI * 4) finalRot += 2 * Math.PI;
    var start = rot, delta = finalRot - start, dur = 4200, t0 = performance.now();
    function frame(now) {
      var t = Math.min((now - t0) / dur, 1);
      var e = 1 - Math.pow(1 - t, 3); // cubic-out
      rot = start + delta * e;
      draw(rot);
      if (t < 1) requestAnimationFrame(frame); else done();
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Vistas ---------- */
  function show(view) {
    ['gate', 'reveal', 'spun'].forEach(function (v) {
      var el = $('.ruleta__view--' + v);
      if (el) el.hidden = (v !== view);
    });
  }
  function openDialog() {
    if (dialog.open) return;
    neutralizeNewsletter();
    openedAt = performance.now();
    try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    sizeCanvas();
  }
  function closeDialog() {
    if (dialog.open) { try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); } }
    refreshTab();
  }

  /* ---------- Embudo del A/B (mostradas / giros) ---------- */
  // Las métricas duras (canjes, revenue) salen de las órdenes con código RULETA-*.
  // Las blandas solo las sabe el front: se reportan acá, fire-and-forget — un fallo
  // de red NUNCA debe romper el giro. Derivamos la URL del endpoint de spin para no
  // agregar otro setting al schema; si el replace no aplica, no mandamos nada (evita
  // postear 'shown' contra /api/spin).
  var TRACK_URL = String(cfg.endpoint || '').replace(/\/spin(\?.*)?$/, '/track');
  function track(event) {
    if (cfg.mock || !TRACK_URL || TRACK_URL === cfg.endpoint) return;
    try {
      fetch(TRACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event: event }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Backend (mock o real) ---------- */
  function pickMockSlice() {
    var total = MOCK_ODDS.reduce(function (a, o) { return a + o[1]; }, 0);
    var x = Math.random() * total;
    for (var i = 0; i < MOCK_ODDS.length; i++) { x -= MOCK_ODDS[i][1]; if (x <= 0) return MOCK_ODDS[i][0]; }
    return MOCK_ODDS[0][0];
  }
  function randCode() {
    var s = '', c = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
    for (var i = 0; i < 6; i++) s += c[Math.floor(Math.random() * c.length)];
    return 'RULETA-' + s;
  }
  // Cupones estáticos que ya existen y están ACTIVE en Shopify: si el backend cae o
  // tarda, entregamos el que corresponde al tier para no romper la experiencia.
  // RULETA5 (5%) / RULETA10 (10%) / RULETA15 (15%) / RULETASHIP (envío gratis).
  var FALLBACK = {
    DISCOUNT_5:    { code: 'RULETA5',    label: '5% OFF',        sliceIndex: 0 },
    DISCOUNT_10:   { code: 'RULETA10',   label: '10% OFF',       sliceIndex: 2 },
    DISCOUNT_15:   { code: 'RULETA15',   label: '15% OFF',       sliceIndex: 6 },
    FREE_SHIPPING: { code: 'RULETASHIP', label: '¡Envío gratis!', sliceIndex: 4 }
  };
  function fallbackResult(tier) {
    var f = FALLBACK[tier] || FALLBACK.DISCOUNT_5;
    return {
      ok: true, fallback: true,
      prize: { tier: tier || 'DISCOUNT_5', label: f.label, sliceIndex: f.sliceIndex },
      code: f.code,
      expiresAt: new Date(Date.now() + 3600 * 1000).toISOString()
    };
  }
  function spin(email, ts, hp) {
    var body = { email: email, ts: ts, company: hp, shop: (window.Shopify && Shopify.shop) || location.host, source: 'ruleta' };
    if (cfg.mock) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          if (hp) { resolve({ ok: false, reason: 'invalid_email' }); return; }
          var idx = pickMockSlice();
          resolve({
            ok: true,
            prize: { tier: SLICES[idx].tier, label: SLICES[idx].label, sliceIndex: idx },
            code: randCode(),
            expiresAt: new Date(Date.now() + 3600 * 1000).toISOString()
          });
        }, 350);
      });
    }
    var ctrl = new AbortController();
    var to = setTimeout(function () { ctrl.abort(); }, 6000);
    return fetch(cfg.endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ctrl.signal
    }).then(function (r) {
      clearTimeout(to);
      return r.json().then(function (j) {
        // Error de servidor (HTTP 500 con reason:"error" y fallbackTier) => degradar.
        if (!r.ok || (j && j.reason === 'error')) { return fallbackResult(j && j.fallbackTier); }
        return j;
      }, function () { return fallbackResult(); }); // JSON ilegible => degradar
    }).catch(function () { clearTimeout(to); return fallbackResult(); }); // red caída / timeout => degradar
  }

  /* ---------- Reveal + countdown ---------- */
  var timerId = null;
  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  function startCountdown(expiresAt) {
    var timerEl = $('[data-ruleta-timer]');
    clearInterval(timerId);
    function tick() {
      var left = new Date(expiresAt).getTime() - Date.now();
      timerEl.textContent = fmt(left);
      if (left <= 0) { clearInterval(timerId); onExpired(); }
    }
    tick();
    timerId = setInterval(tick, 1000);
  }
  function onExpired() {
    localStorage.removeItem(LS_STATE);
    $('[data-ruleta-spun] .ruleta__subtitle').textContent = 'Tu cupón expiró. ¡Gracias por participar!';
    show('spun');
    refreshTab();
  }
  function renderReveal(state) {
    $('[data-ruleta-prize]').textContent = state.label;
    $('[data-ruleta-code]').textContent = state.code;
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    $('[data-ruleta-use]').href = root_ + 'discount/' + encodeURIComponent(state.code) + '?redirect=/collections/all';
    startCountdown(state.expiresAt);
    show('reveal');
  }

  /* ---------- Mini-tab ---------- */
  function refreshTab() {
    var tab = $('[data-ruleta-tab]');
    if (!tab) return;
    var st = readState();
    var valid = st && st.code && new Date(st.expiresAt).getTime() > Date.now();
    tab.hidden = !valid;
  }

  /* ---------- Newsletter: no coexistir ---------- */
  function neutralizeNewsletter() {
    var nl = document.getElementById('newsletter-drawer');
    if (nl && nl.parentNode) nl.parentNode.removeChild(nl);
  }

  /* ---------- Gate de edad ---------- */
  function ageGateVisible() {
    if (!cfg.ageSelector) return false;
    var el = document.querySelector(cfg.ageSelector);
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function whenAgeGateGone(cb) {
    if (!ageGateVisible()) { cb(); return; }
    var iv = setInterval(function () {
      if (!ageGateVisible()) { clearInterval(iv); cb(); }
    }, 500);
  }

  /* ---------- Elegibilidad + triggers ---------- */
  function eligible() {
    if (!cfg.onlyIndex) { /* todas las páginas salvo cart (ya excluido en Liquid) */ }
    else if (root.dataset.pageType !== 'index') return false;
    return true;
  }
  function autoOpenOnce() {
    if (dialog.open) return;
    if (cfg.once && hasSpun()) return;
    if (isDismissed()) return;
    // El age gate (app async) puede inyectarse DESPUÉS del chequeo inicial: re-verificar
    // aquí para nunca abrir por encima del verificador de edad.
    if (ageGateVisible()) { whenAgeGateGone(autoOpenOnce); return; }
    openDialog();
    // 'shown' se cuenta SOLO en la apertura automática: es la impresión real y
    // comparable con las "mostradas" de Wheelio. Reabrir el cupón desde el mini-tab
    // o el hook de QA no es una impresión nueva.
    track('shown');
  }
  function initTriggers() {
    if (!eligible()) return;

    // Si ya ganó y el cupón sigue vivo: solo mostrar el tab (no auto-abrir).
    var st = readState();
    if (st && st.code && new Date(st.expiresAt).getTime() > Date.now()) { refreshTab(); return; }

    if (cfg.once && hasSpun()) { refreshTab(); return; }
    if (isDismissed()) { refreshTab(); return; }

    whenAgeGateGone(function () {
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var opened = false;
      function go() { if (!opened) { opened = true; autoOpenOnce(); } }

      var delay = Math.max(0, (cfg.delay || 10)) * 1000;
      var timedId = setTimeout(go, delay);

      if (isDesktop && cfg.exitIntent) {
        document.addEventListener('mouseout', function onExit(e) {
          if (!e.relatedTarget && e.clientY <= 0) {
            document.removeEventListener('mouseout', onExit);
            clearTimeout(timedId);
            go();
          }
        });
      }
    });
  }

  /* ---------- Wire-up ---------- */
  // Hook de QA: abrir manualmente desde consola -> window.__ruletaOpen()
  window.__ruletaOpen = function () { openDialog(); show('gate'); };

  // Bucket W (control): la ruleta nativa NO se muestra; Wheelio actúa normal.
  if (BUCKET !== 'N') return;

  // Bucket N (nativo): suprimir Wheelio y activar la ruleta nativa.
  suppressWheelio();

  root.hidden = false;
  sizeCanvas();

  root.querySelectorAll('[data-ruleta-close]').forEach(function (b) {
    b.addEventListener('click', closeDialog);
  });
  // El evento 'close' del <dialog> cubre TODAS las vías de cierre (X, declinar,
  // Escape nativo): si cerró sin girar, persistir para no reabrir en cada página.
  dialog.addEventListener('close', function () {
    if (!hasSpun()) markDismissed();
  });
  dialog.addEventListener('cancel', refreshTab); // Esc

  $('[data-ruleta-tab]').addEventListener('click', function () {
    var st = readState();
    if (st && st.code && new Date(st.expiresAt).getTime() > Date.now()) {
      openDialog(); renderReveal(st);
    } else { openDialog(); show('gate'); }
  });

  $('[data-ruleta-copy]').addEventListener('click', function () {
    var code = $('[data-ruleta-code]').textContent;
    var btn = this;
    var ok = function () { btn.classList.add('is-copied'); btn.textContent = '¡Copiado!'; setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = 'Copiar'; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
  });

  $('[data-ruleta-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    if (hasSpun()) { show('spun'); return; }
    var form = e.currentTarget;
    var email = (form.email.value || '').trim();
    var hp = (form.company.value || '').trim();
    var err = $('[data-ruleta-error]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.textContent = 'Ingresa un email válido.'; err.hidden = false; return;
    }
    err.hidden = true;
    var btn = $('[data-ruleta-spin]');
    btn.disabled = true;
    var ts = Math.round(performance.now() - openedAt);

    spin(email, ts, hp).then(function (res) {
      if (!res || !res.ok) {
        btn.disabled = false;
        if (res && res.reason === 'already_spun') { markSpun(); show('spun'); return; }
        if (res && res.reason === 'invalid_email') { err.textContent = 'Ingresa un email válido.'; err.hidden = false; return; }
        if (res && res.reason === 'rate_limited') { err.textContent = 'Demasiados intentos. Vuelve a probar más tarde.'; err.hidden = false; return; }
        err.textContent = 'No pudimos girar la ruleta. Intenta de nuevo.'; err.hidden = false;
        return;
      }
      markSpun();
      // Conversión = email capturado / mostradas (la misma vara que el 19% de Wheelio).
      // Un giro degradado a fallback NO capturó el email en Shopify => no cuenta.
      if (!res.fallback) track('spun');
      spinAnim(res.prize.sliceIndex, function () {
        var state = {
          estado: 'won', code: res.code, expiresAt: res.expiresAt,
          tier: res.prize.tier, label: res.prize.label, sliceIndex: res.prize.sliceIndex
        };
        saveState(state);
        renderReveal(state);
      });
    }).catch(function () {
      btn.disabled = false;
      err.textContent = 'No pudimos girar la ruleta. Intenta de nuevo.'; err.hidden = false;
    });
  });

  window.addEventListener('resize', function () { clearTimeout(tabTimer); tabTimer = setTimeout(sizeCanvas, 150); });

  // Estado inicial de la vista según localStorage
  (function initView() {
    var st = readState();
    if (st && st.code && new Date(st.expiresAt).getTime() > Date.now()) { show('reveal'); }
    else if (cfg.once && hasSpun()) { show('spun'); }
    else { show('gate'); }
  })();

  refreshTab();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTriggers);
  else initTriggers();
})();
